import { KeyboardEvent, MutableRefObject, useContext, useEffect, useRef, useState } from "react";
import { PriceContext } from "src/pages/OfferPage/QuotePrices/QuotePrices";
import { ts } from "src/utils/translate";
import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage"
import { formatRowPrice } from "src/pages/OfferPage/QuotePrices/PriceRowUtils";
import $ from "jquery";
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';
import { Button } from "@mui/material";

export const PriceRow = (props: {
  name: string;
  key?: any;
  valueAbs?: number;
  valuePcnt?: number;
  sectionStart?: boolean;
  highlighted?: boolean;
  highlightedText?: boolean;
  confirmedEdit?: boolean;
  editKey?: string;
  quoteUserProperties?: ProjectQuoteUserProperties

}) => {
  const context = useContext(PriceContext);
  const onEdit = context.onEditHandler;
  const {
    sectionStart,
    editKey,
    confirmedEdit,
    highlighted,
    highlightedText,
    name,
    valuePcnt,
    valueAbs,
    quoteUserProperties
  } = props;

  const [inputValue, setInputValue] = useState(valuePcnt ? +valuePcnt : 0); // Assuming tax rate is at index 1
  const [isFirstChange, setIsFirstChange] = useState(true);

  const inputRef: MutableRefObject<any> = useRef(null);

  const onConfirm = context.onConfirmHandler;
  const currency = context.currency;
  const hasEditPermission = context.hasEditPermission;
  const editable = !!editKey && !!onEdit && hasEditPermission;
  const step = 0;
  const min = 0;
  const max = 100;
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (inputValue !== Number(valuePcnt)) {
      setInputValue(valuePcnt ? +valuePcnt : 0);
    }
  }, [valuePcnt]);

  const handleInputChange = (newValue: number) => {
    if (newValue < 0) {
      newValue = 0;
    }
    if (newValue > 100) {
      newValue = 100;
    }
    setInputValue(newValue);
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (isFirstChange) {
      setIsFirstChange(false);
      return () => {};
    }
    const delayInputTimeoutId = setTimeout(() => {
      onEdit(editKey, Number(inputValue).toString())
    }, 500);
    return () => clearTimeout(delayInputTimeoutId);
  }, [inputValue, editKey]);

  const handleKeyPress = (e: KeyboardEvent) => {
    // Accept only numbers
    if (!/^(0|[1-9][0-9]*)$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleWheel = (e: any) => {
    if (inputRef.current === document.activeElement) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (editable && inputRef && inputRef.current) {
      const ref = inputRef.current;
      const jqRef = $(ref);
      jqRef.off("mousewheel.r");
      jqRef.on("mousewheel.r", handleWheel);
    }
  }, [editable, inputRef]);

  return (
    <tr
      className={`${highlighted ? "last-of-type" : ""}${
        highlightedText ? " last-of-type-text-extra" : ""
      }${confirmedEdit || valuePcnt === 0 ? " remove-on-export" : ""}`}
    >
      <td>
        <h4 style={sectionStart ? { fontWeight: 600 } : { fontWeight: 300 }}>{name}</h4>
      </td>

      <td style={{ textAlign: "right" }}>
        <h4
            style={{
              fontWeight: 600,
              ...(editable && {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "5px",
              }),
            }}
        >
          { editable ? (
            <div
              style={{
                float: "left",
                border: "1px solid #b9b9b9",
                display: "flex",
              }}
              className="remove-on-export"
            >
              <input
                style={{
                  width: 50,
                  height: 24,
                  border: "none",
                  textAlign: "center",
                  fontSize: 15,
                }}
                ref={inputRef}
                className={
                  IS_READ_ONLY_USER
                    ? "number-spin quote-footer-pcnt-input disable"
                    : "number-spin quote-footer-pcnt-input"
                }
                type="number"
                value={inputValue}
                min={min}
                max={max}
                step={step}
                onWheel={(e) => e.preventDefault()}
                onChange={(e) => handleInputChange(+e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                onKeyUp={(e: any) => {
                  e.target.value = Number(+e.target.value).toString()
                  e.key === "Enter" &&
                    onConfirm &&
                    onConfirm(editKey, +(valuePcnt ?? 0));
                }}
                onKeyPress={handleKeyPress}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => {
                  e.target.value = Number(e.target.value).toString();
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 5px",
                  backgroundColor: "transparent",
                  fontSize: 15,
                }}
              >
                %
              </div>
            </div>
          ) : (
            valuePcnt != null && !isNaN(+valuePcnt) && (
              <span style={{ float: "left" }} className="remove-on-export">
                ({valuePcnt}%)
              </span>
            )
          )}

          {valueAbs !== undefined && ((quoteUserProperties != null && quoteUserProperties.include_currency_visibility > 1) || highlighted ) && (
            <span data-val={+valueAbs || 0}>
              {formatRowPrice(+valueAbs || 0, currency)}
            </span>
          )}
          {confirmedEdit &&  (
            <Button
                variant="contained"
                className={
                  IS_READ_ONLY_USER ? "btn blue-uplan disable" : "btn blue-uplan"
                }
                sx={{
                  padding: "2px",
                  paddingX: "7px",
                  color: "white",
                  borderRadius: "6px !important",
                  textTransform: "none",
                  fontSize: "12px"
                }}
                onClick={(e) => onConfirm(editKey, valuePcnt)}
            >
              {ts("q_set_value", "Set value")}
            </Button>
          )}
        </h4>
      </td>
    </tr>
  );
};
